// src/pages/Appli/AppliAdmin/VisitorCenter/components/LiveVisitorsPanel.jsx

import React from "react";

import {
  FiMapPin,
  FiMonitor,
  FiNavigation,
  FiUsers,
} from "react-icons/fi";

import {
  EmptyState,
  ErrorState,
  LoadingState,
  SectionCard,
  StatusBadge,
} from "../ui/VisitorCenterUi";

import {
  formatDevice,
  formatLocation,
  formatPageLabel,
  formatRelativeTime,
  formatTrafficSource,
} from "../utils/visitorFormatters";

export default function LiveVisitorsPanel({
  visitors,
  selectedVisitorId,
  onSelectVisitor,
  loading,
  errorMessage,
}) {
  return (
    <SectionCard
      title="Visiteurs actifs"
      subtitle={`${visitors.length} visiteur(s) actuellement détecté(s)`}
    >
      <ErrorState message={errorMessage} />

      {loading ? (
        <LoadingState label="Recherche des visiteurs..." />
      ) : visitors.length ? (
        <div className="max-h-[760px] space-y-2 overflow-y-auto p-3">
          {visitors.map((visitor) => {
            const active =
              visitor.id === selectedVisitorId;

            return (
              <button
                key={visitor.id}
                type="button"
                onClick={() =>
                  onSelectVisitor(visitor.id)
                }
                className={`w-full rounded-2xl border p-4 text-left transition ${
                  active
                    ? "border-[#2EA7E0] bg-[#EEF7FC] shadow-sm"
                    : "border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50"
                }`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <div className="font-extrabold text-[#123B57]">
                      Visiteur #{visitor.id}
                    </div>

                    <div className="mt-1 text-xs text-slate-500">
                      {formatRelativeTime(
                        visitor.last_seen_at,
                      )}
                    </div>
                  </div>

                  <StatusBadge status={visitor.status} />
                </div>

                <div className="mt-4 rounded-xl bg-white/80 p-3">
                  <div className="truncate text-sm font-bold text-slate-800">
                    {formatPageLabel(
                      visitor.current_page,
                    )}
                  </div>

                  <div className="mt-1 truncate text-xs text-slate-400">
                    {visitor.current_page}
                  </div>
                </div>

                <div className="mt-3 space-y-2 text-xs text-slate-500">
                  <div className="flex items-center gap-2">
                    <FiMapPin />
                    <span className="truncate">
                      {formatLocation(visitor)}
                    </span>
                  </div>

                  <div className="flex items-center gap-2">
                    <FiNavigation />
                    <span className="truncate">
                      {formatTrafficSource(visitor)}
                    </span>
                  </div>

                  <div className="flex items-center gap-2">
                    <FiMonitor />
                    <span className="truncate">
                      {formatDevice(visitor)}
                    </span>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      ) : (
        <EmptyState
          icon={FiUsers}
          title="Aucun visiteur en ligne"
          description="Les nouveaux visiteurs apparaîtront ici automatiquement."
        />
      )}
    </SectionCard>
  );
}